import React, { useCallback, useEffect, useState } from "react";
import { CheckCircle2, Clock3, Package, Truck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { PageShell } from "@/pages/dashboard/RolePages";

const energy = (value) => `⚡ ${Number(value || 0).toLocaleString("es-CO")} Energía KD9`;
const labels = {
  pending_payment: "Pendiente de pago",
  payment_rejected: "Pago rechazado",
  paid: "Pago aprobado",
  preparing: "En preparación",
  shipped: "Enviado",
  delivered: "Entregado",
};
const flow = ["paid", "preparing", "shipped", "delivered"];
const dateTime = (value) => value ? new Date(value).toLocaleString("es-CO") : "Pendiente";

const MarketplaceOrders = () => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    api.get("/api/marketplace/orders/mine")
      .then(({ data }) => { setRows(data); setError(""); })
      .catch((error) => setError(formatApiError(error)));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <PageShell kicker="Usuario · Marketplace" title="MIS PEDIDOS"
      desc="Estado real de tus compras, pagos y envíos." testId="marketplace-orders-page">
      {error && <div className="kd9-card p-4 mb-5" style={{ color: "#FCA5A5" }}>{error}</div>}
      <div className="space-y-4">
        {rows.map((order) => (
          <article key={order.id} className="kd9-card p-5">
            <div className="flex flex-wrap gap-4 items-center">
              <Package size={25} style={{ color: "var(--kd9-gold)" }} />
              <div className="flex-1 min-w-[220px]">
                <div className="font-cinzel">{order.product_name}</div>
                <div className="font-mont text-[10px]">{order.quantity} unidad(es) · {energy(order.total_energy)}</div>
                <div className="font-mont text-[10px]" style={{ color: "var(--kd9-text-soft)" }}>
                  Pedido {order.id} · {order.shipping.address}, {order.shipping.city}
                </div>
              </div>
              <div className="font-mont text-xs uppercase kd9-gold-text">{labels[order.status] || order.status}</div>
              {order.tracking_code && (
                <div className="font-mont text-xs">
                  <Truck size={13} className="inline" /> {order.carrier || "Transportadora"} · {order.tracking_code}
                </div>
              )}
            </div>
            <div className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-4">
              {flow.map((step, index) => {
                const reached = flow.indexOf(order.status) >= index;
                const event = (order.status_history || []).find((item) => item.status === step);
                return <div key={step} className={`rounded-xl border p-3 ${reached ? "border-cyan-400/30 bg-cyan-400/5" : "border-white/10 opacity-45"}`}>
                  <div className="flex items-center gap-2 font-mont text-[9px] uppercase">{reached ? <CheckCircle2 size={13} className="text-cyan-300" /> : <Clock3 size={13} />}{labels[step]}</div>
                  <div className="mt-1 font-mont text-[9px]" style={{ color: "var(--kd9-text-soft)" }}>{dateTime(event?.at)}</div>
                </div>;
              })}
            </div>
          </article>
        ))}
      </div>
      {!rows.length && <div className="kd9-card p-12 text-center font-cormorant text-xl">Aún no tienes pedidos.</div>}
    </PageShell>
  );
};

export default MarketplaceOrders;
